import { render, staticRenderFns } from "./client-basic.vue?vue&type=template&id=0c65e55c&scoped=true"
import script from "./client-basic.vue?vue&type=script&lang=js"
export * from "./client-basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c65e55c",
  null
  
)

export default component.exports